import { NavigateOptions, useNavigate } from "react-router-dom";
import { EmployeeCard } from "../../components";
import { IDoctor, IRoom, IRegisterState, RegisterType } from "../../models";

type DoctorItemProps = {
  doctor: IDoctor;
  room: IRoom;
}

export const DoctorItem = ({ doctor, room }: DoctorItemProps) => {
  const navigate = useNavigate();

  if (!doctor) {
    return null;
  }

  const registerState: IRegisterState = {
    type: RegisterType.Doctor,
    employee: doctor,
    room: room
  };

  const navOptions: NavigateOptions = {
    state: registerState
  };

  return (
    <EmployeeCard
      gender={doctor.gender}
      onClick={() => navigate("/register", navOptions)}
      title={(doctor.title ? doctor.title + ' ' : '') + doctor.name}
      room={room}
    />
  )
}